// extracted by mini-css-extract-plugin
module.exports = {"container":"CardDealerChip_container__7fvLW","hide":"CardDealerChip_hide__5yKSb"};